import React, { FC } from 'react';
import { TechnicalErrorPage as TechnicalErrorPagePk } from 'omni-package-react-core';
import { StyledDiv } from '~/pages/TechnicalErrorPage/TechnicalErrorPage.styles';

export interface NotFoundPageProps { }

const TechnicalErrorPage: FC<NotFoundPageProps> = () => (
  <StyledDiv>
    <TechnicalErrorPagePk />
  </StyledDiv>
);

export default TechnicalErrorPage;
